import { render } from "./InfiniteScroll.vue?vue&type=template&id=158d18c9&scoped=true"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js"

import "./InfiniteScroll.vue?vue&type=style&index=0&id=158d18c9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158d18c9"]])

export default __exports__